import loadable from '@loadable/component';

export const setTagLine = (text) => {
    const element = document.getElementById('header-logo-adaptive-text');
    if(element) {
        element.innerHTML = text;
    }
};

export const preloadComponent = (component, callback) => {
    if (component && component.preload) {
        if(typeof callback === 'function'){
            component.load().then(() => {
                callback();
            });
        }

        component.preload();
    }
    return null;
};

export const dynamicImport = (factory) => {
    const Component = /* #__LOADABLE__ */ loadable(factory, { ssr: true, suspense: false });

    // if(typeof document !== 'undefined'){
    //     Component.preload = factory;
    // } else {
    //     Component.preload = () => {};
    // }

    return Component;
};
